/** Default Terms & Conditions templates for List Your Show (Additional info step). */

export const TNC_TEMPLATES = [
  { value: "default", label: "Default Tnc" },
  { value: "blank", label: "Blank" },
];

export const DEFAULT_TNC_POINTS = [
  "The organizer reserves the right of admission.",
  "Entry is permitted only after a thorough security check. Please cooperate with the security staff.",
  "Please carry a valid government-issued photo ID for verification at the venue.",
  "Tickets once booked cannot be exchanged or refunded, except as required by applicable law or platform policy.",
  "Children below the age mentioned on the event page may not be allowed entry, unless stated otherwise.",
  "Outside food and beverages are not allowed inside the venue.",
  "Alcohol consumption is permitted only in designated areas, if licensed for the event.",
  "The event is a drug-free zone. Possession or use of illegal substances will lead to eviction and possible legal action.",
  "Weapons, fireworks, lasers, and other hazardous items are strictly prohibited.",
  "Professional cameras, recording equipment, and drones are not allowed without prior written permission.",
  "Please follow all instructions given by venue staff and security personnel.",
  "The organizer is not responsible for any loss, theft, or damage to personal belongings.",
  "Parking is subject to availability and venue rules. The organizer is not liable for vehicle-related incidents.",
  "In case of any medical emergency, please contact the nearest medical / first-aid booth immediately.",
  "The schedule, lineup, and artists are subject to change without prior notice.",
  "The organizer reserves the right to change the venue or cancel the event due to unforeseen circumstances.",
  "In case of cancellation, the refund policy communicated at the time of booking will apply.",
  "Resale of tickets at a premium or through unauthorized channels is not allowed.",
  "By entering the venue, you consent to being photographed or filmed for promotional purposes.",
  "Please reach the venue well in advance to avoid last-minute entry delays.",
  "Any decision of the organizer regarding entry, conduct, or eviction shall be final.",
  "By purchasing a ticket and/or attending the event, you agree to abide by all the above terms and conditions.",
];

export function pointsToHtml(points = []) {
  const items = points
    .map((p) => String(typeof p === "string" ? p : p?.point || "").trim())
    .filter(Boolean);
  if (!items.length) return "";
  return `<ol>${items.map((p) => `<li>${escapeHtml(p)}</li>`).join("")}</ol>`;
}

export function htmlToPoints(html = "") {
  const text = String(html || "");
  const liMatches = [...text.matchAll(/<li[^>]*>([\s\S]*?)<\/li>/gi)];
  if (liMatches.length) {
    return liMatches
      .map((m) => stripHtml(m[1]).trim())
      .filter(Boolean)
      .map((point) => ({ point }));
  }
  const plain = stripHtml(text)
    .split(/\n+/)
    .map((s) => s.replace(/^\d+[\).\s]+/, "").trim())
    .filter(Boolean);
  if (!plain.length) return [{ point: "" }];
  return plain.map((point) => ({ point }));
}

function stripHtml(s) {
  return String(s || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/\s+/g, " ")
    .trim();
}

function escapeHtml(s) {
  return String(s || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

export function templateToHtml(templateValue) {
  if (templateValue === "blank") return "";
  return pointsToHtml(DEFAULT_TNC_POINTS);
}

export function templateToPoints(templateValue) {
  if (templateValue === "blank") return [{ point: "" }];
  return DEFAULT_TNC_POINTS.map((point) => ({ point }));
}
